/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'unread': {
    width: 22,
    height: 19,
    viewBox: '0 0 22 19',
    data: '<defs><path pid="0" d="M11 3.632c2.76 0 5 2.24 5 5 0 .51-.1 1-.24 1.46l3.06 3.06c1.39-1.23 2.49-2.77 3.18-4.53-1.73-4.38-6-7.49-11-7.49-1.27 0-2.49.2-3.64.57l2.17 2.17c.47-.14.96-.24 1.47-.24zM1.71.292a.996.996 0 000 1.41l1.97 1.97A11.892 11.892 0 000 8.633c1.73 4.39 6 7.5 11 7.5 1.52 0 2.97-.3 4.31-.82l2.72 2.72a.996.996 0 101.41-1.41L3.13.293c-.39-.39-1.03-.39-1.42 0zM11 13.633c-2.76 0-5-2.24-5-5 0-.77.18-1.5.49-2.14l1.57 1.57c-.03.18-.06.37-.06.57 0 1.66 1.34 3 3 3 .2 0 .38-.03.57-.07l1.57 1.57c-.65.32-1.37.5-2.14.5zm2.97-5.33a2.97 2.97 0 00-2.64-2.64l2.64 2.64z" id="svgicon_unread_a"/></defs><use _fill="#000" xlink:href="#svgicon_unread_a" fill-rule="evenodd"/>'
  }
})
